import styled from "@emotion/styled";
import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import theme from "../../theme";

export const ContentComponent = styled(DialogContent)`
  margin: 10px 0 0;
  padding: 10px;
  overflow: initial;
`;
export const DialogTitleStyle = styled(DialogTitle)`
  background-color: ${theme.palette.secondary.main};
  color: ${theme.palette.common.white};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

interface DialogTitleAlignmentProps {
  titleAlignment?: "center" | "left" | "right" | string;
}
export const DialogTitleAlignment = styled.div<DialogTitleAlignmentProps>`
  display: flex;
  justify-content: ${props => props.titleAlignment};
  width: 100%;
  height: 100%;
`;

export const DialogCloseIcon = styled(IconButton)`
  color: ${theme.palette.common.white};
`;

export const FullScreenDialogTitleWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.5rem;
`;

export const FullScreenDialogTitleText = styled(Typography)``;

export const DialogActionsStyle = styled(DialogActions)`
  border-bottom: 1px solid ${theme.palette.divider};
`;
